import { render } from "./DefaultLandingHeader.vue?vue&type=template&id=5dff9a6c&scoped=true"
import script from "./DefaultLandingHeader.vue?vue&type=script&lang=js"
export * from "./DefaultLandingHeader.vue?vue&type=script&lang=js"

import "./DefaultLandingHeader.vue?vue&type=style&index=0&id=5dff9a6c&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dff9a6c"]])

export default __exports__